import { BodyText, LabelText } from '@policygenius/mortar';
import React, { useMemo, useState } from 'react';

import Icon from 'components/Icon';

import styles from './account-indicator.module.scss';
import { Props } from './types';

const closeIcon = <Icon icon="close" height="18px" width="18px" className={styles['close-icon']} />;

const AccountIndicator: React.FC<Props> = ({ email, firstName }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const iconInitial = firstName ? firstName[0] : email[0].toUpperCase();

  const circleInitialIcon = useMemo(
    () => (
      <LabelText size="large" color="white" className={styles['circle-initial']}>
        {iconInitial}
      </LabelText>
    ),
    [iconInitial]
  );
  const mobileIcon = menuOpen ? closeIcon : circleInitialIcon;

  const handleClick = () => setMenuOpen(!menuOpen);

  return (
    <div className={styles.container}>
      <button
        className={styles.indicator}
        onClick={handleClick}
        aria-label={menuOpen ? 'Close Navigation Menu' : 'Open Navigation Menu'}
        type="button"
      >
        <div className={styles['mobile-indicator']}>{mobileIcon}</div>
        <div className={styles['desktop-indicator']}>
          {circleInitialIcon}
          {!!firstName && (
            <LabelText size="large" className={styles.greeting}>
              {`Hi, ${firstName}`}
            </LabelText>
          )}
        </div>
      </button>

      {menuOpen && (
        <div className={styles.menu}>
          <div className={styles['name-email']}>
            {!!firstName && <LabelText size="large">{firstName}</LabelText>}
            <BodyText size="small" color="secondary">
              {email}
            </BodyText>
          </div>
          <ul className={styles['nav-link-container']}>
            <li>
              <BodyText as="a" href="/dashboard">
                Dashboard
              </BodyText>
            </li>
            <li>
              <BodyText as="a" href="/users/sign_out">
                Logout
              </BodyText>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default AccountIndicator;
